module.exports = __webpack_public_path__ + "static/media/logo2.82b76363.png";